import type { SimpleFilterDefinition } from '@/sections/insights/queryBuilder/entities/types';

interface DateValueInputProps {
  value: string | string[];
  onChange: (newValue: string | string[]) => void;
  disabled: boolean;
  filterDefinition: SimpleFilterDefinition;
}

export const DateValueInput = ({
  value,
  onChange,
  disabled,
}: DateValueInputProps) => {
  const formatValue = (val: string | string[]): string => {
    if (Array.isArray(val)) {
      return val[0] || '';
    }
    return String(val);
  };

  return (
    <input
      type="date"
      disabled={disabled}
      value={formatValue(value)}
      onChange={e => onChange(e.target.value)}
      className={`flex-[3.5] rounded border px-3 py-1.5 text-sm ${
        disabled
          ? 'border-chariot-stroke bg-chariot-background-primary text-chariot-text-secondary cursor-not-allowed opacity-90'
          : 'border-chariot-stroke bg-chariot-background-primary text-chariot-text-primary hover:border-chariot-brand-primary'
      }`}
      aria-label="Filter value"
    />
  );
};
